import { Box, styled } from '@mui/material';

export const CalculsBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  padding: theme.spacing(2),
}));
